import { IFormArr } from '@/components/types'

export const basicFormConfig: IFormArr = {
  iForms: [
    {
      formItems: [
        {
          label: '客户姓名',
          field: 'customerName',
          type: 'default',
          isDisabled: true
        },
        {
          label: '客户昵称',
          field: 'custNickName',
          type: 'input',
          maxLength: 50,
          placeholder: '请输入客户昵称'
        }
      ]
    },
    {
      formItems: [
        {
          label: '开发账号',
          field: 'exploitAccount',
          type: 'input',
          maxLength: 50,
          placeholder: '请输入开发账号'
        },
        {
          label: '资金量',
          type: 'select',
          field: 'funds',
          placeholder: '请选择资金量',
          options: [
            { title: '<5万', value: '0' },
            { title: '5-10万', value: '1' },
            { title: '≥10万', value: '2' }
          ]
        }
      ]
    },
    {
      formItems: [
        {
          label: '认可老师',
          type: 'select',
          field: 'proveTeacher',
          multiple: true,
          placeholder: '请选择老师'
        },
        {
          label: '资源承接日期',
          field: 'undertakeDate',
          type: 'datepicker',
          otherOptions: {
            placeholder: '选择资源承接日期',
            type: 'datetime',
            'value-format': 'YYYY-MM-DD HH:mm:ss'
          }
        }
      ]
    },
    {
      formItems: [
        {
          label: '开单金额',
          field: 'openAmount',
          type: 'input',
          maxLength: 50,
          placeholder: '请输入开单金额'
        },
        {
          label: '开单日期',
          field: 'openDate',
          type: 'datepicker',
          otherOptions: {
            placeholder: '选择开单日期',
            type: 'datetime',
            'value-format': 'YYYY-MM-DD HH:mm:ss'
          }
        }
      ]
    },
    {
      formItems: [
        {
          label: '备注',
          field: 'remark',
          type: 'textarea',
          maxLength: 300,
          placeholder: '请输入备注',
          rows: 2
        }
      ]
    },
    {
      formItems: [
        {
          label: '资金证明图',
          field: 'proofImgUrls',
          type: 'slot'
        },

        {
          label: '认可老师证明图',
          field: 'proveImgUrls',
          type: 'proveSlot'
        }
      ]
    },

    {
      formItems: [
        {
          label: '上传录音',
          field: 'recordingUrls',
          type: 'fileSolt'
        }
      ]
    },
    {
      formItems: [
        {
          label: '部门',
          field: 'deptName',
          type: 'default'
        },
        {
          label: '员工',
          field: 'empName',
          type: 'default',
          isDisabled: true
        }
      ]
    },
    {
      formItems: [
        {
          label: '填报日期',
          field: 'fillDate',
          type: 'default',
          isDisabled: true
        },
        {
          label: '业绩核实结果',
          field: 'verifyResult',
          type: 'input',
          isHidden: true
        }
      ]
    }
  ]
}
